wbApp.controller('AsideCtrl', ['$scope', '$timeout', 'securitySvc', 'previewInterestSvc', 'semesterSvc', 'tenantSettingSvc', 'tenantInfo', 'uiUtilsSvc',
  function ($scope, $timeout, securitySvc, previewInterestSvc, semesterSvc, tenantSettingSvc, tenantInfo, uiUtilsSvc) {

      $scope.roles = securitySvc.roles;

      $scope.user = securitySvc.loggedInUser();
      $scope.scrollbarWidth = uiUtilsSvc.getScrollbarWidth()

      var activeSemesterPromise = semesterSvc.getActiveAsync();
      activeSemesterPromise.then(function (activeSemester) {
          if (activeSemester) {
              if (securitySvc.isInRole('PreviewHours')) {
                  $scope.previewInterests = previewInterestSvc.getAll(activeSemester.id);
              }
          }
      });
      
      $scope.allowDiscounts = tenantSettingSvc.settings.allowDiscounts;
      $scope.enableKindergartenSupport = tenantSettingSvc.settings.enableKindergartenSupport;
      $scope.enableRfidCardSupport = tenantSettingSvc.settings.enableRfidCardSupport;
      $scope.isFranchiseCentral = tenantInfo.isFranchiseCentral;
      $scope.isFranchiseCentralAndSupportSubjectLicenses = tenantInfo.isFranchiseCentral && tenantInfo.franchiseCentralSettings.supportSubjectLicenses;

      $scope.isFranchise = !!_.find(tenantInfo.franchiseCentrals, { isActive: true });
      $scope.enableDataExportHistory = tenantSettingSvc.settings.enableDataExport;
      $scope.enableOnlinePayments = tenantSettingSvc.settings.enablePaymentGateways;
      $scope.createTaxDocuments = tenantSettingSvc.settings.createTaxDocuments;
      $scope.enableReservationSupport = tenantSettingSvc.settings.enableReservationSupport;
      $scope.enableOnlineMeetings = tenantSettingSvc.settings.enableZoomIntegration;
      $scope.enableRentSupport = tenantSettingSvc.settings.enableRentSupport;
      $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;

      $scope.minifyAsideClick = function () {
          $('body').toggleClass("minified");
          $timeout(function () {
              $('body').resize();
          }, 100);
      }

  }]);